import React from 'react';
import { Modal } from './Modal';
import styled from "styled-components";

export interface ErrorMessageModalProps {
  message: string;
  isError: boolean;
  setIsError: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ErrorMessageModal: React.FC<ErrorMessageModalProps> = ({ message, isError, setIsError }) => {
  return (
    <Modal
      header={
        <div>{"Error"}</div>
            }
      body={
        <div dangerouslySetInnerHTML={{__html:message}}/>
      }
      actions={<button onClick={() => setIsError(false)}>{"OK"}</button>}
      onBackdropClick={() => (setIsError(false))}
    />
  );
};
